import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HomeService } from '../../../../services/home.service';
import { Item } from '../../../../interfaces/item';
import { Stockitem } from '../../../../interfaces/stockitem';
import { LanguageServiceService } from '../../../../services/language-service.service';
import { LogoutService } from '../../../Authentication/auth/logout.service';
import { BehaviorSubject } from 'rxjs';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Governorate } from '../../../../interfaces/governorate';
import { GovernoratesService } from '../../../../services/governorates.service';
import { City } from '../../../../interfaces/city';
import { ExcelExportService } from '../../../../services/excel-export.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { PageEvent } from '@angular/material/paginator';
import Swal from 'sweetalert2';
import { UserService } from '../../../../services/user';
import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { PointOfSaleService } from '../../../../services/pos';
import e from 'express';
import { SalesByLocationsService } from '../../../../services/salesbylocations';

@Component({
  selector: 'app-salesbylocations',
  templateUrl: './salesbylocations.component.html',
  styleUrl: './salesbylocations.component.scss'
})


export class SalesbylocationsComponent implements OnInit {
  allData: Stockitem[] = [];
  totalItems = 0;

  isAr: boolean = localStorage.getItem("language") == "ar";
  displayedColumns: string[] = [
    'order_id',
    'city',
    'address',
    'products'
  ];


  imageURL = '/assets/Home.png';
  contentReady: boolean = true;
  noData: boolean = false;
  searched: boolean = false;
  focusOnSreach: boolean = false;
  AllCategoryactive: boolean = true;
  Medicinsactive: boolean = false;
  Injectionsactive: boolean = false;
  WheelChairsactive: boolean = false;
  isFilterDataOpen: boolean = false;
  FilterDataForm!: FormGroup;
  start_date?: string;
  end_date?: string;
  category_id?: number;
  governorates: Governorate[] = [];
  city_id?: number;
  location?: Governorate;
  cities: City[] = [];
  id?: string;
  quantity?: string;
  itemId?: string;
  stockTotal?: string;
  showRejectPopUp: boolean = false;
  isMobile: boolean = false;
  cartPopUp: boolean = false;
  accountType!: string;
  isAdmin!: boolean;
  isSubAdmin!: boolean;
  searchKey: string = '';
  cartItems: any[] = [];
  cartItemCount: number = 0;
currentPage = 1;
perPage = 10;
  total = 0;
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private router: Router,

    private deviceService: DeviceDetectorService,
    private _userService: UserService,
    private salesService: SalesByLocationsService
  ) {

    this.dataSource = new MatTableDataSource(this.allData);
  }

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobileDevice();


    this._userService.getAccountType().subscribe({
      next: (data) => {

        this.accountType = data['user_type'];
        this.isAdmin = this.accountType == "1" || this.accountType == "10";
        this.isSubAdmin = this.accountType == "6";

         this.loadData(null, null, this.currentPage, this.perPage);
      },
      error: (error) => console.error(error),
    });


  }




loadData(city_id?: any, product_id?: any,currentPage?: any, perPage?: any) {
  this.salesService
    .getSalesLocations(city_id, product_id, currentPage, perPage)
    .subscribe((res: any) => {

      this.dataSource = new MatTableDataSource(res.data);

      this.total = res.total;

      this.contentReady = false;


    });
}

  deleteItem(id: number) {
    if (!confirm('Delete this record?')) return;

    this.salesService.deleteLocation(id).subscribe(() => {
      this.loadData(null, null, this.currentPage, this.perPage);
    });
  }








onPaginateChange(event: PageEvent) {
  this.currentPage = event.pageIndex + 1;
  this.perPage = event.pageSize;

        this.loadData(null, null, this.currentPage, this.perPage);
}

  formatDate(date: string): string {
    const d = new Date(date);
    const day = d.getDate().toString().padStart(2, '0');
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const year = d.getFullYear().toString().slice(2); // Getting last two digits of the year
    return `${day}-${month}-${year}`;
  }


}
